import React from "react";
import { Routes, Route } from "react-router-dom";
import AthleteDashboard from "../components/AthleteDashboard/AthleteDashboard";
import AthleteProfile from '../components/AthleteDashboard/AthleteProfile';
import TrainingZones from "../components/TrainingZones/TrainingZones";

const AthleteRoutes = () => {
  return (
    <Routes>
      <Route path="/athlete-dashboard" element={<AthleteDashboard />} />
      <Route path="/athlete-profile" element={<AthleteProfile />} />
      <Route path="/training-zones" element={<TrainingZones />} />
    </Routes>
  );
};

export default AthleteRoutes;
